import React, { useEffect, useState, useRef } from "react";
import Profile_BG from "../../Assets/Images/Profile_BG.png";

import axios from "axios";
import Swal from "sweetalert2";
import { Pencil, Upload, Trash2, X } from "lucide-react";
import UploadImg from "../../components/Cloudinary/UploadImage";
import defaultProfile from "../../Assets/Images/default_img.png";
import Loader from "../../components/common/Loader";
const Profile = () => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({});
  const [editLoading, setEditLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  const dateInputRef = useRef(null);

  const formatDate = (isoString) => {
    if (!isoString) return "N/A";
    const date = new Date(isoString);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const fetchDetails = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/admins/get-admin-by-id/${id}`
      );
      const startTime = Date.now();
      setAdmin(response.data.admin);
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(1000 - elapsed, 0);

      setTimeout(() => setLoading(false), remaining);
    } catch (error) {
      console.error("Error fetching admin details:", error);
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  useEffect(() => {
    const storedAdmin = localStorage.getItem("adminDetails");
    if (storedAdmin) {
      const parsedAdmin = JSON.parse(storedAdmin);
      const adminId = parsedAdmin._id || parsedAdmin.id;
      if (adminId) {
        fetchDetails(adminId);
      } else {
        console.error("No admin ID found in localStorage:", parsedAdmin);
      }
    } else {
      console.error("No admin details found in localStorage");
    }
  }, []);

  const handleEditClick = () => {
    setIsEditing(true);
    setEditLoading(true);
    setTimeout(() => {
      setEditData(admin);
      setPreviewImage(admin?.profilePic || null);
      setEditLoading(false);
    }, 800);
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      Swal.fire({
        title: "Uploading...",
        text: "Please wait while your image uploads.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const uploadedUrl = await UploadImg(file);
      setEditData({ ...editData, profilePic: uploadedUrl });
      setPreviewImage(uploadedUrl);

      Swal.close();
      Swal.fire({
        icon: "success",
        title: "Uploaded!",
        text: "Profile image updated successfully.",
        timer: 1200,
        showConfirmButton: false,
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Upload failed",
        text: "Unable to upload image. Try again later.",
      });
    }
  };

  const handleRemoveImage = () => {
    setPreviewImage(null);
    setEditData({ ...editData, profilePic: "" });
  };

 const handleSave = async () => {
  try {
    // Validate mobile number
    const phone = editData.phoneNumber || "";
    if (phone.length !== 10) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Mobile Number",
        text: "Please enter a valid 10-digit mobile number before saving.",
        confirmButtonColor: "#3085d6",
      });
      return; // stop update
    }

    setEditLoading(true);

    const allowedFields = [
      "name",
      "email",
      "phoneNumber",
      "gender",
      "dateOfBirth",
      "address",
      "nationality",
      "profilePic",
    ];

    const filteredData = Object.keys(editData)
      .filter((key) => allowedFields.includes(key))
      .reduce((obj, key) => {
        obj[key] = editData[key];
        return obj;
      }, {});

    const response = await axios.patch(
      `${process.env.REACT_APP_API_URL}/admins/admin-edit-profile/${admin._id}`,
      filteredData
    );

    setAdmin(response.data.admin);
    setIsEditing(false);
    setEditLoading(false);
    localStorage.setItem("adminDetails", JSON.stringify(response.data.admin));

    Swal.fire({
      icon: "success",
      title: "Profile Updated!",
      text: "Your changes have been saved successfully.",
      showConfirmButton: false,
      timer: 1500,
    });
  } catch (error) {
    console.error("Error saving profile:", error);
    setEditLoading(false);

    Swal.fire({
      icon: "error",
      title: "Update Failed",
      text:
        error.response?.data?.message ||
        "There was a problem saving your profile.",
    });
  }
};


 
  //   const { name, value } = e.target;

  //   // For mobile number validation
  //   if (name === "phoneNumber") {
  //     // Allow only numbers and limit to 10 digits
  //     const numericValue = value.replace(/\D/g, ""); // remove non-numeric characters
  //     if (numericValue.length <= 10) {
  //       setEditData({ ...editData, [name]: numericValue });
  //     }
  //   } else {
  //     setEditData({ ...editData, [name]: value });
  //   }
  // };
const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === "phoneNumber") {
  
    const numericValue = value.replace(/\D/g, "");
    if (numericValue.length <= 10) {
      setEditData({ ...editData, [name]: numericValue });
    }
  } else {
    setEditData({ ...editData, [name]: value });
  }
};


  const handleDateChange = (e) => {
    const value = e.target.value;
    if (value) {
      const date = new Date(value);
      const isoDate = new Date(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
      ).toISOString();
      setEditData({ ...editData, dateOfBirth: isoDate });
    } else {
      setEditData({ ...editData, dateOfBirth: "" });
    }
  };

  if (loading) return <Loader />;

  if (!admin)
    return (
      <div className="text-center mt-20 text-red-500">No admin data found.</div>
    );

  return (
    <div className="max-w-6xl mx-4 xl:mx-auto border-2 mt-20 rounded-2xl shadow-xl relative bg-white overflow-hidden mb-24 lg:mb-32 xl:mb-96 2xl:mb-[77rem]">
      <div className="relative rounded-lg">
        <img
          src={Profile_BG}
          alt="Profile background"
          className="w-full h-48 sm:h-56 md:h-64 object-cover mt-10 rounded-xl px-6"
        />
        <div className="absolute -bottom-10 left-6 sm:left-10">
          <img
            src={admin?.profilePic || "N/A"}
            alt="Profile"
            className="w-24 h-24 sm:w-28 sm:h-28 rounded-full border-4 border-white shadow-lg object-cover"
          />
        </div>
        <button
          onClick={handleEditClick}
          className="absolute top-8 right-10 rounded-full bg-blue-500 text-white px-2 py-2 transition"
        >
          <Pencil size={16} />
        </button>
      </div>

      <div className="pt-16 pb-10 px-6 sm:px-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8 ">
          {[
            { label: "Full Name", value: admin.name },
            { label: "Email", value: admin.email },
            { label: "Mobile Number", value: admin.phoneNumber },
            {
              label: "Gender",
              value: admin.gender
                ? admin.gender.charAt(0).toUpperCase() + admin.gender.slice(1)
                : "N/A",
            },
          ].map((field, index) => (
            <div key={index} className="break-words">
              <h2 className="text-lg font-semibold text-gray-900 truncate">
                {field.value || "N/A"}
              </h2>
              <p className="text-sm text-gray-500">{field.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 ">
          {[
            { label: "Date of Birth", value: formatDate(admin.dateOfBirth) },
            {
              label: "Address",
              value: admin.address
                ? admin.address.charAt(0).toUpperCase() + admin.address.slice(1)
                : "N/A",
            },
            { label: "Nationality", value: admin.nationality },
          ].map((field, index) => (
            <div key={index} className="break-words">
              <h2 className="text-lg font-semibold text-gray-900 truncate">
                {field.value || "N/A"}
              </h2>
              <p className="text-sm text-gray-500">{field.label}</p>
            </div>
          ))}
        </div>
      </div>

      {isEditing && (
        <div className="fixed inset-0 flex justify-center items-center bg-black/50 z-50 px-4">
          <div className="bg-white rounded-xl shadow-lg w-full max-w-2xl p-6 relative max-h-[90vh] overflow-y-auto">
            {editLoading ? (
              <div className="animate-pulse space-y-4">
                <div className="h-6 bg-gray-300 rounded w-1/2 mx-auto"></div>
                {[...Array(7)].map((_, i) => (
                  <div key={i}>
                    <div className="h-4 bg-gray-200 rounded w-1/3 mb-2"></div>
                    <div className="h-10 bg-gray-200 rounded"></div>
                  </div>
                ))}
                <div className="flex justify-end gap-3 mt-6">
                  <div className="h-10 bg-gray-200 rounded w-20"></div>
                  <div className="h-10 bg-gray-300 rounded w-20"></div>
                </div>
              </div>
            ) : (
              <>
                <h2 className="fixed text-2xl font-semibold mb-5 text-left">
                  Edit Profile
                </h2>

                <div className="flex flex-col items-center mb-6">
                  <div className="relative">
                    <img
                      src={previewImage || defaultProfile}
                      alt="Preview"
                      className="w-28 h-28 rounded-full object-cover border-4 border-gray-200 shadow"
                      onError={(e) => (e.target.src = defaultProfile)}
                    />
                    <label
                      htmlFor="profilePicUpload"
                      className="absolute bottom-0 right-0 bg-blue-500 text-white p-2 rounded-full cursor-pointer hover:bg-blue-600"
                    >
                      <Upload size={16} />
                    </label>
                    <input
                      id="profilePicUpload"
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      className="hidden"
                    />
                    {previewImage && (
                      <button
                        onClick={handleRemoveImage}
                        className="absolute top-0 right-0 bg-red-500 text-white p-1 rounded-full hover:bg-red-600"
                      >
                        <Trash2 size={14} />
                      </button>
                    )}
                  </div>
                  <p className="text-sm text-gray-500 mt-2">Profile Picture</p>
                </div>

                <div className="grid grid-cols-1 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">
                      Full Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={editData.name || ""}
                      onChange={handleChange}
                      className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={editData.email || ""}
                      onChange={handleChange}
                      className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">
                      Mobile Number
                    </label>
                    <input
                      type="text"
                      name="phoneNumber"
                      value={editData.phoneNumber || ""}
                      onChange={handleChange}
                      maxLength={10}
                      inputMode="numeric"
                      pattern="[0-9]*"
                      placeholder="Enter 10-digit mobile number"
                      className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">
                      Gender
                    </label>
                    <select
                      name="gender"
                      value={editData.gender || ""}
                      onChange={handleChange}
                      className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    >
                      <option value="">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">
                      Date of Birth
                    </label>
                    <div className="relative">
                      <input
                        ref={dateInputRef}
                        type="date"
                        name="dateOfBirth"
                        value={formatDateForInput(editData.dateOfBirth)}
                        onChange={handleDateChange}
                        className="w-full border rounded-lg px-3 py-2 pr-10 focus:outline-none focus:ring-2 focus:ring-blue-400"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">
                      Address
                    </label>
                    <textarea
                      name="address"
                      value={editData.address || ""}
                      onChange={handleChange}
                      rows={2}
                      className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    ></textarea>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">
                      Nationality
                    </label>
                    <input
                      type="text"
                      name="nationality"
                      value={editData.nationality || ""}
                      onChange={handleChange}
                      className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    />
                  </div>
                </div>

                <div className="flex justify-end gap-3 mt-6">
                  <button
                    onClick={() => setIsEditing(false)}
                    className="px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100 transition"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleSave}
                    className="px-4 py-2 bg-primaryBtnColor text-white rounded-md hover:bg-blue-700 transition"
                  >
                    Update
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;
